
import MonitorApi from './src/Monitor'
import RegionApi from './src/Region'
import EquipmentApi from './src/Equipment'
import SwiperVideoApi from './src/SwiperGet'
import SwiperListApi from './src/SwiperPost'
import PassengerFlowApi from './src/PassengerFlowApi'
import MonitorPermissionApi from './src/MonitorPermission'

let apis = {
   MonitorApi,
   RegionApi,
   EquipmentApi,
   SwiperVideoApi,
   SwiperListApi,
   PassengerFlowApi,
   MonitorPermissionApi
   
};

export default apis;
